import useUpdate from "@/hooks/use-update";
import { UseLoadingReturn } from "@/hooks/use-loading";
import { IClosedDaysInput } from "@/interfaces/closed-days.interface";
import closedDaysService from "@/services/closed-days.service";
import { RequestsProps } from "@/types/requests.types";

export type Props = {
  formData: IClosedDaysInput;
  _id: number;
} & RequestsProps;

export type Return = {
  update: (props: Props) => Promise<void>;
} & UseLoadingReturn;

const useUpdateClosedDays = (): Return => {
  const { isLoading, startLoading, endLoading, loadingIcon, update } = useUpdate<IClosedDaysInput>({
    operation: (formData, _id) => closedDaysService.update(formData, _id),
  });

  return { isLoading, startLoading, endLoading, loadingIcon, update };
};

export default useUpdateClosedDays;
